exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spectacle-deck>div>div>div>div>div>.start-level-container{margin:5vw 15vw;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.spectacle-deck>div>div>div>div>div>.start-level-container h1{margin:0;color:#61d9f2;font-size:20vw;line-height:.8em;letter-spacing:normal;-ms-flex:1;flex:1}.spectacle-deck>div>div>div>div>div>.start-level-container p{font-size:2vw;text-transform:uppercase}.spectacle-deck>div>div>div>div>div>.start-level-container .btn{margin-right:10px}@media (max-width:400px){.spectacle-deck>div>div>div>div>div>.start-level-container .btn{white-space:normal;line-height:20px;padding:17px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/components/startLevel.scss
// module id = 1314
// module chunks = 2